import { engineComponent, ArrayUtils } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { BaseElement } from "./BaseElement";
import { Vibration } from "../../../Utils/Vibration";

@engineComponent(ComponentTypes.DisplayObject)
export class VibrationElement extends BaseElement {
    createByNode(node: Element): void {
        //
    }

    updateByNode(node: Element): void {
        if (node.hasAttribute(VibrationElementAttributes.PATTERN)) {
            const pattern = ArrayUtils.numberArray(node.getAttribute(VibrationElementAttributes.PATTERN));
            Vibration.vibrate(pattern);
        }
    }

    clone(): VibrationElement {
        const element: VibrationElement = new VibrationElement();
        return element;
    }
}

export const VibrationElementAttributes = {
    PATTERN: "Pattern",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Graphics/VibrationElement.ts
 **/